export default __webpack_public_path__ + "static/media/Vector 103.bce746c2.svg";